import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Heading,
  Input,
  Textarea,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Select,
  HStack,
  VStack,
  Spinner,
  useToast,
} from '@chakra-ui/react';

const BASE_URL = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/') + "api";

const FaqPage = () => {

  const token = localStorage.getItem('adminToken');
  const toast = useToast();

  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    question: '',
    answer: '',
    status: 'active',
  });

  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadFaqs();
  }, []);

  // GET FAQ
  const loadFaqs = async () => {
    try {

      const res = await axios.get(`${BASE_URL}/faq`);

      setFaqs(res.data.data);

    } catch (error) {

      toast({
        title: 'Error loading FAQs',
        status: 'error',
      });

    } finally {
      setLoading(false);
    }
  };

  // CREATE / UPDATE
  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      if (editingId) {

        await axios.put(
          `${BASE_URL}/faq/${editingId}`,
          form,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        toast({
          title: 'FAQ updated',
          status: 'success',
        });

      } else {

        await axios.post(
          `${BASE_URL}/faq`,
          form,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        toast({
          title: 'FAQ created',
          status: 'success',
        });

      }

      setForm({
        question: '',
        answer: '',
        status: 'active',
      });

      setEditingId(null);

      loadFaqs();

    } catch (error) {

      toast({
        title: 'Operation failed',
        status: 'error',
      });

    }
  };

  // EDIT
  const editFaq = (faq) => {

    setForm({
      question: faq.question,
      answer: faq.answer,
      status: faq.status,
    });

    setEditingId(faq._id);
  };

  // DELETE
  const removeFaq = async (id) => {

    if (!window.confirm('Delete FAQ?')) return;

    try {

      await axios.delete(
        `${BASE_URL}/faq/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      toast({
        title: 'FAQ deleted',
        status: 'success',
      });

      loadFaqs();

    } catch {

      toast({
        title: 'Delete failed',
        status: 'error',
      });

    }
  };

  if (loading)
    return (
      <Box p="40px">
        <Spinner size="xl" />
      </Box>
    );

  return (
    <Box p="40px" mt="80px">

      <Heading mb="6">FAQ Management</Heading>

      {/* FORM */}

      <Box bg="white" p="6" rounded="lg" shadow="md" mb="10">

        <VStack spacing="4">

          <Input
            placeholder="Enter Question"
            value={form.question}
            onChange={(e) => setForm({ ...form, question: e.target.value })}
          />

          <Textarea
            placeholder="Enter Answer"
            value={form.answer}
            onChange={(e) => setForm({ ...form, answer: e.target.value })}
          />

          <Select
            value={form.status}
            onChange={(e) => setForm({ ...form, status: e.target.value })}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </Select>

          <Button colorScheme="blue" onClick={handleSubmit} width="full">
            {editingId ? 'Update FAQ' : 'Add FAQ'}
          </Button>

        </VStack>

      </Box>

      {/* TABLE */}

      <Box bg="white" p="6" rounded="lg" shadow="md">

        <Table variant="simple">

          <Thead bg="gray.100">
            <Tr>
              <Th>#</Th>
              <Th>Question</Th>
              <Th>Answer</Th>
              <Th>Status</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>

          <Tbody>

            {faqs.map((faq, index) => (

              <Tr key={faq._id}>

                <Td>{index + 1}</Td>

                <Td fontWeight="semibold">
                  {faq.question}
                </Td>

                <Td maxW="400px">
                  {faq.answer}
                </Td>

                <Td>{faq.status}</Td>

                <Td>

                  <HStack>

                    <Button
                      size="sm"
                      colorScheme="yellow"
                      onClick={() => editFaq(faq)}
                    >
                      Edit
                    </Button>

                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={() => removeFaq(faq._id)}
                    >
                      Delete
                    </Button>

                  </HStack>

                </Td>

              </Tr>

            ))}

          </Tbody>

        </Table>

      </Box>

    </Box>
  );
};

export default FaqPage;
